module.exports = __webpack_public_path__ + "img/computericon.6c32a7df.png";